import {
  Col,
  Image,
  Row,
  Card,
  Tabs,
  Tag,
  Checkbox,
  Typography,
  Spin,
} from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import React, { useState, useEffect } from "react";
import spuServices from "../services/spu";

import './CategorySelector.css';

// let getRightDivInterval: any = null;

interface CategoryItem {
  id: number;
  name: string;
  img: string;
  children?: CategoryItem[];
}

interface TagListProps {
  tags: CategoryItem[];
  onTagClose: (id: number) => void;
}

const TagList = ({ tags, onTagClose }: TagListProps) => {
  const handleChange = (id: number) => onTagClose(id);

  return (
    <>
      {tags.map((tag) => (
        <Tag
          key={tag.id}
          closable
          style={{ margin: 5 }}
          onClose={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            e.preventDefault();
            handleChange(tag.id);
          }}
        >
          {tag.name}
        </Tag>
      ))}
    </>
  );
};

interface CategoryCardProps {
  category: CategoryItem;
  checked: boolean;
  onCheckboxChange: (category: CategoryItem, checked: boolean) => void;
}

const CategoryCard = ({
  category,
  checked,
  onCheckboxChange,
}: CategoryCardProps) => {
  const handleChange = (e: CheckboxChangeEvent) => {
    onCheckboxChange(category, e.target.checked);
  };

  return (
    <Card
      className='category-selector-components'
      bodyStyle={{
        padding: 5,
        width: 150,
        height: 200,
      }}
    >
      <Checkbox
        style={{
          position: "absolute",
          left: 3,
          top: 0,
          width: "100%",
          height: "100%",
          zIndex: 999,
        }}
        checked={checked}
        onChange={handleChange}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 140,
          height: 140,
          overflow: "hidden"
        }}
      >
        <Image
          key={category.id}
          src={category.img}
          className='category-selector-image'
          preview={false}
          placeholder
          // fallback="data:image/png;base64,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"
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // wordBreak: "break-all",
          height: 56,
        }}
      >
        <Typography.Paragraph
          style={{
            textAlign: "center",
            margin: 0,
            lineHeight: "18px"
          }}
        >
          {category.name}
        </Typography.Paragraph>
      </div>
    </Card>
  );
};

interface CategoryValue {
  selected?: number[];
}

interface CategorySelectorProps {
  value?: CategoryValue;
  onChange?: (value: CategoryValue) => void;
}

const CategorySelector = ({ value = {}, onChange }: CategorySelectorProps) => {
  const [categories, setCategories] = useState<CategoryItem[] | null>(null);

  const flatCategories: CategoryItem[] = categories
    ? (categories.map((category) => category.children).flat() as CategoryItem[])
    : [];

  const initValue: CategoryItem[] = value.selected
    ? (value.selected
        .map((id) => flatCategories.find((c) => c.id === id))
        .filter((item) => item) as CategoryItem[])
    : [];

  const [selectedCategories, setSelectedCategories] = useState<CategoryItem[]>(
    []
  );

  const [selected, setSelected] = useState<number[]>([]);

  // const [style, setStyle] = useState<any>({});

  const getCategories = async () => {
    const result = await spuServices.getCategories();
    const data = result.data.response || [];

    setCategories(data.filter((item: CategoryItem) => item.children));
  };

  useEffect(() => {
    // getRightDivInterval = setInterval(() => {
    //   const rightDiv: any = document.querySelector('div.assp-right');
    //   const searchDiv: any = document.querySelector('form.assp-search');
  
    //   if (rightDiv && searchDiv) {
    //     clearInterval(getRightDivInterval);
    //     getRightDivInterval = null;
  
    //     const width = rightDiv.offsetWidth;
    //     const searchHeight = searchDiv.offsetHeight;
    //     const finalHeight = width - searchHeight - 192;
  
    //     if (finalHeight > 0) {
    //       setStyle({
    //         height: `${finalHeight}px`
    //       });
    //     }
    //   }
    // }, 100);

    getCategories();
    return () => setCategories([]);
  }, []);

  useEffect(() => {
    if (!categories) {
      return;
    }

    if ("selected" in value && value.selected) {
      const newSelectedCategory = value.selected
        .map((id) => flatCategories.find((c) => c.id === id))
        .filter((item) => item) as CategoryItem[];

      setSelectedCategories(newSelectedCategory);
      setSelected(value.selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const triggerChange = (changedValue: CategoryValue) => {
    onChange?.({ selected, ...value, ...changedValue });
  };

  const handleTagClose = (id: number) => {
    const newSeletedCategories = selectedCategories.filter(
      (category) => category.id !== id
    );
    const newSelected = selected.filter((item) => item !== id);

    if (!("selected" in value)) {
      setSelectedCategories(newSeletedCategories);
      setSelected(newSelected);
    }

    triggerChange({ selected: newSelected });
  };

  const handleCheckbox = (category: CategoryItem, checked: boolean) => {
    let newSelectedCategories = [];
    let newSelected = [];

    if (checked) {
      newSelectedCategories = [...selectedCategories, category];
      newSelected = [...selected, category.id];
    } else {
      newSelectedCategories = selectedCategories.filter(
        (item) => item.id !== category.id
      );
      newSelected = selected.filter((item) => item !== category.id);
    }

    if (!("selected" in value)) {
      setSelectedCategories(newSelectedCategories);
      setSelected(newSelected);
    }

    triggerChange({ selected: newSelected });
  };

  // 如果分类没有加载完成，则显示 Spin
  if (!categories) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <>
      <TagList
        tags={initValue || selectedCategories}
        onTagClose={handleTagClose}
      />
      <Tabs tabPosition="top">
        {categories.map((category) => (
          <Tabs.TabPane tab={category.name} key={category.id}>
            <div
              className='category-main'
              // style={style}
            >
              <Row justify="start">
                {category.children &&
                  category.children.map((item: any) => (
                    <Col key={item.id}>
                      <CategoryCard
                        category={item}
                        checked={(initValue || selectedCategories).includes(item)}
                        onCheckboxChange={handleCheckbox}
                      />
                    </Col>
                  ))}
              </Row>
            </div>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </>
  );
};

export default CategorySelector;
